/* eslint-disable no-unused-vars */
import { all } from 'redux-saga/effects';
import authSagas from './auth/saga';
import activeIngredient from './activeIngredient/saga';
import catalogList from './catalogList/saga';
import unit from './unit/saga';
import dosageForm from './dosageForm/saga';
import dosageFormGroup from './dosageFormGroup/saga';
import salt from './salt/saga';
import routeAdministration from './routeAdministration/saga';
import routeAdministrationGroup from './routeAdministrationGroup/saga';
import dispensingUnit from './dispensingUnit/saga';
import dataMedication from './dataMedication/saga';
import atc from './atc/saga';
import unspscFamily from './unspscFamily/saga';
import unspscClass from './unspscClass/saga';
import unspsc from './unspsc/saga';
import news from './news/saga';
import article from './article/saga';
import search from './search/saga';
import user from './user/saga';
import demand from './demand/saga';
import acquisition from './acquisition/saga';
import supplier from './supplier/saga';
import acquisitionDetail from './acquisitionDetail/saga';
import code22 from './code22/saga';
import code22Review from './code22Review/saga';
import dashboard from './dashboard/saga';
import kpiMatrix from './kpiMatrix/saga';
import snapshot from './snapshot/saga';
import orp from './orp/saga';
import orpcompras from './orpcompras/saga';
import externalReview from './external_review/saga';
import upload from './upload/saga';
import adminUser from './adminUser/saga';
import marketintelPrice from './marketintelPrice/saga';
import marketintelBid from './marketintelBid/saga';
import marketintelArticle from './marketintelArticle/saga';
import marketintelSupplier from './marketintelSupplier/saga';
import marketintelOpenning from './marketintelOpenning/saga';
import publicationDocument from './publicationDocument/saga';
import gobAward from './gobAward/saga';
import award from './award/saga';
import accessView from './accessView/saga';
import articleList from './articleList/saga';
import supplierInfo from './supplierInfo/saga';
import razonabilidad from './razonabilidad/saga';
import userRole from './userRole/saga';
import dataQuality from './dataQuality/saga';
import menuRole from './menuRole/saga';
import formKpiLcr from './formKpiLcr/saga';
import articleCard from './article_card/saga';

export default function* rootSaga(getState) {
  yield all([
      authSagas(),
      activeIngredient(),
      unit(),
      dosageForm(),
      dosageFormGroup(),
      salt(),
      routeAdministration(),
      routeAdministrationGroup(),
      dispensingUnit(),
      dataMedication(),
      atc(),
      unspsc(),
      unspscFamily(),
      unspscClass(),
      news(),
      article(),
      search(),
      user(),
      demand(),
      acquisition(),
      supplier(),
      acquisitionDetail(),
      code22(),
      code22Review(),
      dashboard(),
      kpiMatrix(),
      snapshot(),
      orp(),
      orpcompras(),
      externalReview(),
      upload(),
      catalogList(),
      adminUser(),
      marketintelPrice(),
      marketintelBid(),
      marketintelArticle(),
      marketintelSupplier(),
      marketintelOpenning(),
      publicationDocument(),
      gobAward(),
      award(),
      accessView(),
      articleList(),
      supplierInfo(),
      razonabilidad(),
      userRole(),
      dataQuality(),
      menuRole(),
      formKpiLcr(),
      articleCard()
  ]);
}
